import { render, staticRenderFns } from "./LandsideFooterOld.vue?vue&type=template&id=7510d4d2&scoped=true&"
import script from "./LandsideFooterOld.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LandsideFooterOld.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./LandsideFooterOld.vue?vue&type=style&index=0&id=7510d4d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7510d4d2",
  null
  
)

export default component.exports